import { useGlobalQuery } from '@/state/query-client/hooks';
import { getActivityLogs } from '../services/activity-log.service';
import { GetActivityLogsParams } from '../types/activity-log.types';

export const useGetActivityLogs = (params: GetActivityLogsParams) => {
  return useGlobalQuery({
    queryKey: ['hr-activity-logs', params],
    queryFn: () => getActivityLogs(params),
    staleTime: 30 * 1000,
  });
};
